import usePromoBannerUpdater from '@/features/promoBanners/usePromoBannerUpdater';
// import useRouteConfig from '@/features/routeConfig/useRouteConfig';
import useStrikethroughUpdater from '@/features/strikethrough/useStrikethroughUpdater';

const PROMO_BANNERS_UPDATE_INTERVAL = 900; // In seconds
const STRIKETHROUGH_UPDATE_INTERVAL = 900; // In seconds

type TProps = { children: React.ReactNode };

const GraphQLUpdaters = ({ children }: TProps) => {
  // const { hasBannerPlaces, hasStrikethrough } = useRouteConfig() || {};

  usePromoBannerUpdater({
    isEnabled: true, // hasBannerPlaces,
    repeatInterval: PROMO_BANNERS_UPDATE_INTERVAL,
  });
  useStrikethroughUpdater({
    isEnabled: true, // hasStrikethrough,
    repeatInterval: STRIKETHROUGH_UPDATE_INTERVAL,
  });

  return children;
};

export default GraphQLUpdaters;
